import {
  NotificationListItem,
  NotificationListItemProps,
} from '@common/notifications/notification-list';
import {PaymentIcon} from '@common/icons/material/Payment';

export function PaymentNotificationRenderer(
  props: NotificationListItemProps
) {
  return <NotificationListItem lineIconRenderer={IconRenderer} {...props} />;
}

interface IconRendererProps {
  icon: string;
}
function IconRenderer({icon}: IconRendererProps) {
  // For payment notifications, we'll use a PaymentIcon
  return <PaymentIcon className="w-16 h-16 text-green-500" />;
}
